import {FC, ReactNode} from "react"
import {useLocation} from "react-router-dom"

import {regionFromRouteExtractor} from "./regionFromRouteExtractor"

import {setRegionFromRegionNumber} from "@indebted/api"

export const RegionWrapper: FC<{children: ReactNode}> = ({children}) => {
	const location = useLocation()

	const searchParams = new URLSearchParams(location.search)
	const region = regionFromRouteExtractor(location.pathname, searchParams, window.location.hostname)

	if (region === undefined) {
		console.error("No region found", location.pathname, searchParams)
	} else {
		setRegionFromRegionNumber(region)
	}

	return <>{children}</>
}
